import * as React from 'react';
export const bksSvg = React.forwardRef(function bksSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EF2D38',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        fillRule: 'nonzero',
        d: 'M24.92 15.07c1.17.4 2.41.92 2.41 2.5 0 1.48-1.4 2.8-3.43 2.8a7.27 7.27 0 0 1-3.2-.8l.45-1.74c.82.57 1.8.87 2.8.88.85 0 1.34-.37 1.34-.94 0-.85-1.01-1.06-2.08-1.42-1.09-.32-2.18-.89-2.18-2.3 0-1.3 1.25-2.41 3.4-2.41 1.7 0 2.68.5 2.68.5l-.46 1.74s-1.1-.66-2.42-.66c-.71 0-1.23.26-1.23.66 0 .67.94.85 1.92 1.19zm-8.71.72 4.1 4.57h-2.63l-3.13-4.23v4.23h-2.42v-8.72h2.42v4.02l3.16-4.02h2.42l-3.92 4.15zm-7.16-.3s1.84.18 1.84 1.96c0 1.68-1.29 2.91-3.73 2.91-1.7 0-2.8-.27-2.8-.27v-8.3s1.21-.15 2.99-.15c2.15 0 3.24.72 3.24 1.97 0 1.56-1.54 1.88-1.54 1.88zm-.42-1.48c0-.63-.53-1-1.44-1-.64 0-.95.05-.95.05v2.04s.4.03.87.03c1.1 0 1.52-.45 1.52-1.12zm-1.26 4.91c1.21 0 1.56-.62 1.56-1.35 0-.76-.45-1.25-1.66-1.25-.5 0-1.02.04-1.02.04v2.48c.37.06.75.1 1.12.08z',
      }),
    ),
  );
});
bksSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var bks = {
  category: 'brand',
  colorable: false,
  name: 'bks',
  svg: bksSvg,
};
